<form (ngSubmit)="submitForm()" class="contact-form" #form="ngForm">
  <button class="close-btn" (click)="closeForm()">×</button>

  <div class="form-group">
    <div class="form-control-wrapper">
      <input
        #firstNameInput
        type="text"
        placeholder="First Name *"
        [(ngModel)]="contactForm.first_name"
        name="first_name"
        #firstName="ngModel"
        required
        autocomplete="given-name"
        [disabled]="submitSuccess"
      />
      @if (firstName.invalid && firstName.touched) {
        <div class="error-message">First name is required.</div>
      }
    </div>

    <div class="form-control-wrapper">
      <input
        type="text"
        placeholder="Last Name"
        [(ngModel)]="contactForm.last_name"
        name="last_name"
        autocomplete="family-name"
        [disabled]="submitSuccess"
      />
    </div>
  </div>

  <div class="form-control-wrapper">
    <input
      type="email"
      placeholder="Email *"
      [(ngModel)]="contactForm.email"
      name="email"
      #email="ngModel"
      required
      email
      autocomplete="email"
      [disabled]="submitSuccess"
    />
    @if (email.invalid && email.touched) {
      <div class="error-message">
        @if (email.errors?.["required"]) {
          <span>Email is required.</span>
        }
        @if (email.errors?.["email"]) {
          <span>Enter a valid email.</span>
        }
      </div>
    }
  </div>
  <div class="form-control-wrapper">
    <input
      type="tel"
      placeholder="Phone"
      [(ngModel)]="contactForm.phone"
      name="phone"
      #phone="ngModel"
      pattern="^[0-9+\-\s]*$"
      autocomplete="tel"
      [disabled]="submitSuccess"
    />
    @if (phone.invalid && phone.touched) {
      <div class="error-message">Enter a valid phone number.</div>
    }
  </div>
  <div class="form-control-wrapper">
    <input
      type="text"
      placeholder="Business Name"
      [(ngModel)]="contactForm.company"
      name="business"
      autocomplete="organization"
      [disabled]="submitSuccess"
    />
  </div>
  <div class="form-control-wrapper">
    <textarea
      placeholder="Your requirements *"
      [(ngModel)]="contactForm.requirements"
      name="requirements"
      #requirements="ngModel"
      required
      minlength="10"
      autocomplete="off"
      [disabled]="submitSuccess"
    ></textarea>
    @if (requirements.invalid && requirements.touched) {
      <div class="error-message">
        @if (requirements.errors?.["required"]) {
          <span>This field is required.</span>
        }
        @if (requirements.errors?.["minlength"]) {
          <span>Please enter at least 10 characters.</span>
        }
      </div>
    }
  </div>
  <button
    type="submit"
    [disabled]="form.invalid || isSubmitting || submitSuccess"
  >
    {{ isSubmitting ? "Sending Message..." : "Send Message" }}
  </button>

  @if (submitSuccess) {
    <p class="success-message">Message sent successfully!</p>
  }
  @if (submitError) {
    <p class="error-message">{{ submitError }}</p>
  }
</form>
